var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:min-h-screen flex justify-center items-center flex-col"},[(_vm.tab == -2)?_c('TokenInvalid'):_vm._e(),(_vm.tab == -1)?_c('LoanLoadingForm'):(_vm.tab == 0)?_c('div',{staticStyle:{"border-radius":"8px"}},[_c('ReviewForm',{attrs:{"guarantor":_vm.guarantor}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }